export const supportsLocalstorage = () => {
    const mod = 'analyticsContext';
    try {
        localStorage.setItem(mod, mod);
        localStorage.removeItem(mod);
        return true;
    }
    catch (e) {
        return false;
    }
};
//# sourceMappingURL=supportsLocalstorage.js.map